export default __webpack_public_path__ + "static/media/img-error-text.cb32513e.svg";